import React from "react";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
function Loader({ text = 'Loading', className }) {
    return (<div className={"page-loader " + className}>
      <Trans>{text}</Trans>
    </div>);
}
export default Loader;
